import type { StyleResolverContext, CssFragment } from './index';

// ============================================================================
// Scrollbar CSS
// ============================================================================

/** Returns standard + WebKit CSS for styled scrollbar. Use when scrollX or scrollY is true. */
const getScrollbarCss = (theme: StyleResolverContext): string => {
  const thumbColor = theme.getColor('scrollbar.thumb');
  const trackColor = theme.getColor('scrollbar.track');
  const size = theme.getLayout('scrollbar', 'size');
  const radius = theme.getLayout('scrollbar', 'radius');

  return `
    scrollbar-width: thin;
    scrollbar-color: ${thumbColor} ${trackColor};
    &::-webkit-scrollbar {
      width: ${size};
      height: ${size};
      border-radius: ${radius};
      background-color: ${trackColor};
    }
    &::-webkit-scrollbar-thumb {
      background-color: ${thumbColor};
      border-radius: ${radius};
    }
  `;
};

// ============================================================================
// Style resolver
// ============================================================================

export const resolveScrollbarStyleCss = (
  props: Record<string, unknown>,
  theme: StyleResolverContext,
): CssFragment[] => {
  const { scrollX, scrollY } = props as { scrollX?: boolean; scrollY?: boolean };
  return scrollX || scrollY ? [getScrollbarCss(theme)] : [];
};
